import { render, staticRenderFns } from "./RecursiveList.vue?vue&type=template&id=48f32fc0&"
import script from "./RecursiveList.vue?vue&type=script&lang=js&"
export * from "./RecursiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports